import { NgModule } from '@angular/core';
import { ForecastSearchService } from '@app/forecast/core/services/forecast-search.service';

@NgModule({
  imports: [],
  providers: [ForecastSearchService],
})
export class ForecastCoreModule {}
